export default function InvestorConfidence() {
  const signals = [
    { icon: 'ri-compass-3-line', title: 'Market Fit Signals' },
    { icon: 'ri-alert-line', title: 'Risk & Red Flag Scan' },
    { icon: 'ri-bar-chart-box-line', title: 'Competitive Strength Indicators' },
    { icon: 'ri-line-chart-line', title: 'Traction Quality Score' },
    { icon: 'ri-trophy-line', title: 'Success Probability Score' },
    { icon: 'ri-shield-check-line', title: 'Benchmark Confidence Profile' }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-slate-900 via-slate-800 to-teal-900 text-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Built for Founders — Trusted by Investors
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            CrowdRounds gives investors a standardized, evidence-based view of your app's potential.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {signals.map((signal, index) => (
            <div
              key={index}
              className="p-6 bg-white/10 backdrop-blur-sm rounded-xl border border-white/20 hover:bg-white/15 hover:border-teal-400 transition-all duration-300 group"
            >
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-gradient-to-br from-teal-400 to-teal-600 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className={`${signal.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-lg font-bold text-white group-hover:text-teal-300 transition-colors">
                  {signal.title}
                </h3>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <a
            href="/for-investors"
            className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-teal-500 to-teal-600 text-white font-bold rounded-xl hover:from-teal-600 hover:to-teal-700 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
          >
            See Investor Insights
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
